import { useMemo } from 'react';
import Icon from '@ant-design/icons';
import { Button } from 'antd';
import { ReactComponent as SvgForward } from 'assets/icons/forward.svg';
import { Detail } from 'components/Refund';
import { useOpenReturnStatus } from 'hooks/business/openReturnStatus';
import { useTranslate } from '@tolgee/react';
import { openExternalURL } from 'utils/openExternalURL';

/** 卖家中心退款详情入口（单一职责：Shopee 卖家中心/跨境店跳转内容） */
export function useShopeeSellerRefundContent(params: {
  platform: General.PlatformUpperCase;
  storeType: Conversation.Trade.IStoreType;
  externalStoreId: string;
  orderSn: string;
  returnSn: string;
}) {
  const { platform, storeType, externalStoreId, orderSn, returnSn } = params;
  const { t } = useTranslate();
  const openReturn = useOpenReturnStatus();

  return useMemo(() => {
    if (platform !== 'SHOPEE') return null;

    if (openReturn) {
      return (
        <Detail externalStoreId={externalStoreId} externalTradeId={orderSn} returnSn={returnSn}>
          {t('scene.orderWorkspace.returnRefundTab.detail.action.viewRefundDetailInSellerCenter')}
        </Detail>
      );
    }

    if (storeType === 'CROSS') {
      return (
        <Button
          type="default"
          size="small"
          onClick={() => {
            openExternalURL(
              `https://seller.shopee.cn/portal/sale/returnlist?cnsc_shop_id=${externalStoreId}`,
              '__blank',
            );
          }}
        >
          {t('scene.orderWorkspace.returnRefundTab.detail.action.viewRefundDetailInSellerCenter')}{' '}
          <Icon component={SvgForward} />
        </Button>
      );
    }

    return null;
  }, [platform, openReturn, storeType, externalStoreId, orderSn, returnSn, t]);
}
